import Vue from "vue";
import VueResource from "vue-resource";
import { API_ROOT } from "../config";

Vue.use(VueResource);

// Vue.http.options.crossOrigin = true
// Vue.http.options.credentials = true

/*if (process.env.NODE_ENV === "production") {
  throw new Error("Missing API root");
  // Vue.http.options.root = ...
}*/

Vue.http.interceptors.push((request, next) => {
  request.headers = request.headers || {};
  request.headers.set("Authorization", localStorage.getItem("Authorization"));
  next(response => {
    if (response.status === 401) {
      if (!window.location.pathname === "/login")
        window.location.pathname = "/login";
    }
  });
});

export const AuthResource = Vue.resource(API_ROOT + "auth");
export const SignUpResource = Vue.resource(API_ROOT + "signup");
export const ActivateAccountResource = Vue.resource(
  API_ROOT + "activate/{token}"
);
export const MySelfResource = Vue.resource(API_ROOT + "myself");
export const ForgotPasswordResource = Vue.resource(
  API_ROOT + "forgot_password"
);
export const ResetPasswordResource = Vue.resource(
  API_ROOT + "reset_password{/token}"
);

export const UserResource = Vue.resource(API_ROOT + "user");
export const UserCreateResource = Vue.resource(API_ROOT + "user");
export const UserReadResource = Vue.resource(API_ROOT + "user/{id}");
export const UserUpdateResource = Vue.resource(API_ROOT + "user/{id}");
export const UserDeleteResource = Vue.resource(API_ROOT + "user/{id}");

export const LineResource = Vue.resource(API_ROOT + "line");
export const LineCreateResource = Vue.resource(API_ROOT + "line");
export const LineUpdateResource = Vue.resource(API_ROOT + "line/{id}");
export const LineDeleteResource = Vue.resource(API_ROOT + "line/{id}");

export const PolResource = Vue.resource(API_ROOT + "pol");
export const PolCreateResource = Vue.resource(API_ROOT + "pol");
export const PolUpdateResource = Vue.resource(API_ROOT + "pol/{id}");
export const PolDeleteResource = Vue.resource(API_ROOT + "pol/{id}");

export const SettingResource = Vue.resource(API_ROOT + "setting");
export const SettingCreateResource = Vue.resource(API_ROOT + "setting");
export const SettingUpdateResource = Vue.resource(API_ROOT + "setting/{id}");
export const SettingDeleteResource = Vue.resource(API_ROOT + "setting/{id}");